exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".check input{display:none}.check input:checked+label{color:#fff;background-color:#ea5e0b}.check input:checked+label i{color:#fff}.check label{position:relative;background-color:#e2e2e2;color:#999;margin-bottom:5px;padding:0 10px;font-family:Open Sans;font-size:1.5rem;font-weight:400;text-transform:none;transition:all .25s ease}.check label i{position:absolute;right:10px;font-size:2.3rem;color:#999;top:50%;transform:translateY(-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58eaebd0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/installation/InformationInstallation.vue
// module id = 638
// module chunks = 0